import React, { FC } from 'react';
import { Box, Container, Grid, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/events-module/MotorcycleEventsViewV2/components/EventsAndFilterSection/EventsAndFilterSection.styles';
import { EventAndRidesCardV2Skeleton } from 'views/rebranded-module/common/components';

const EventsAndFilterSectionSkeleton: FC = () => {
  return (
    <StyledBox>
      <Container maxWidth="xl" className="EFSContent">
        {/* Filters Container */}
        <Box className="EFSFiltersContainer">
          {[...Array(2)].map((_, item) => (
            <Skeleton
              key={item}
              variant="rectangular"
              width={200}
              height={56}
              sx={{ borderRadius: 1 }}
              className="EFSEventInput"
            />
          ))}
        </Box>

        {/* Events Grid */}
        <Grid container columnSpacing={6} rowSpacing={{ lg: 8, md: 5, xs: 5 }}>
          {[...Array(6)].map((_, item) => (
            <Grid item xs={12} md={12} lg={6} key={item}>
            <EventAndRidesCardV2Skeleton />
            </Grid>
          ))}
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { EventsAndFilterSectionSkeleton };
